import { createComponentStore } from '../../utils/createComponentStore';

const emptyTemplateData = () => ({
  sourceProjectId: '',
  sourceComponentId: '',
  connectionData: null,
});

const { createStore, getStore, defaultStore } = createComponentStore({
  type: 'trigger_from_a_workflow',
  endpoint: 'triggerFromAWorkflow',
  registryKey: 'triggerFromAWorkflow',
  initData: emptyTemplateData,

  onLoadData: (rawData, component) => {
    const cd = component.componentData;
    return {
      ...emptyTemplateData(),
      sourceProjectId: rawData.sourceProjectId ?? cd.sourceProjectId ?? '',
      sourceComponentId: rawData.sourceComponentId ?? cd.sourceComponentId ?? '',
      connectionData: rawData.connectionData ?? cd.connectionData ?? null,
      ...rawData,
    };
  },

  extraActions: (set, get) => ({
    // Backward-compat alias
    resetStore: () => get().initialiseEmpty(),

    // Backward-compat alias
    setTriggerFromAWorkflowTemplate: (component) => get().setComponentData(component),

    // Backward-compat alias
    setTriggerFromAWorkflowName: (name) => set({ name }),
  }),
});

export function getTriggerFromAWorkflowStore(componentId) {
  return getStore(componentId);
}

export default defaultStore;
